// extracted by mini-css-extract-plugin
module.exports = {"newsSectionContainer":"newsSection_newsSectionContainer__117Sf","divider":"newsSection_divider__1Bt0Z"};